<template>
  <el-dialog :title="$lang('选择运单')" :visible="visible" @close="visible = false" custom-class="waybill-dialog" width="1000px" height="637">
    <avue-crud ref="params" :data="waybillData.records" :option="listOpt" :page="page" :table-loading="loading" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
      <template slot="menu" slot-scope="{row}">
        <span class="el-icon-circle-check" :title="$lang('选择')" style="color: #2D7CFF;font-size: 18px;" @click="selectItem(row)"></span>
      </template>
    </avue-crud>
  </el-dialog>
</template>

<script>
import { RecordSheet } from './pool'
import { RESPONSE_CODE } from '@public/http/config'
import mixin from '@mixins/mixin'
import { DICT } from '@/common/utils/dict'

export default {
  name: 'WaybillDialog',
  mixins: [mixin],
  data() {
    return {
      visible: false,
      loading: false,
      queryObj: {
        customerPhone: '',
        current: 1,
        size: 10
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      waybillData: {
        records: [],
        current: 1, //  当前页码
        size: 10, //  每页数据量
        total: 1
      }
    }
  },
  computed: {
    listOpt() {
      return {
        tableHeight: '420px',
        searchShow: false,
        header: false,
        search: false,
        ignorePermission: true,
        align: 'center',
        menuAlign: 'center',
        menuWidth: 50,
        btnsVisible() {
          return { view: false }
        },
        column: [
          {
            label: '工单号',
            prop: 'workOrderNo'
          },
          {
            label: '运单编号',
            prop: 'waybillNo',
            formatter({ waybillNo }) {
              return waybillNo
            }
          },
          {
            label: '工单类型',
            prop: 'workOrderType',
            type: 'select',
            dicData: DICT.W_orkorderTypeTwo
          },
          {
            label: '来电号码',
            prop: 'customerPhone'
          },
          {
            label: '最后处理时间',
            prop: 'updateTime'
          },
          {
            label: '工单状态',
            prop: 'status',
            type: 'select',
            dicData: DICT.W_orkorderStatus
          }
        ]
      }
    }
  },
  methods: {
    async setFormparams() {
      this.loading = true
      try {
        const { data, code, msg } = await RecordSheet.reqWaybillList(this.queryObj)
        this.loading = false
        if (code === RESPONSE_CODE.SUCCESS) {
          this.waybillData = data
          this.page = data
        } else {
          this.$message.warning(msg)
        }
      } catch (err) {
        console.error(err)
        this.loading = false
      }
    },
    selectItem(item) { // 选择后传回父级进行回填单号
      this.visible = false
      this.$emit('selectWaybill', item)
    },
    show(phoneNum) { // 点击查询弹出选择运单框
      this.queryObj.customerPhone = phoneNum
      this.queryObj.current = 1
      this.queryObj.size = 10
      this.setFormparams()
      this.visible = true
    },
    handleSizeChange(val) {
      this.queryObj.size = val
      this.queryObj.current = 1 // 在选择每页条数时，需将页数初始化
      this.setFormparams()
    },
    handleCurrentChange(val) {
      this.queryObj.current = val
      this.setFormparams()
    }
  }
}
</script>

<style lang="scss">
.waybill-dialog {
  .el-icon-circle-check {
    cursor: pointer;
  }
}
</style>
